<ng-content select="mip-within-viewport-child"></ng-content>
